import React, { useContext, useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import Popover from "@mui/material/Popover";
import Button from "@mui/material/Button";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { string, bool, func } from "prop-types";
import { useNavigate } from "react-router-dom";
import "./HeaderLogin.scss";
import { PersonOutlineOutlined } from "@mui/icons-material";
import LogoutIcon from '@mui/icons-material/Logout';
import { LoginDataContext } from "../../context-api/LoginDataProvider";
import { isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper';
import AtomicButton from "../button/AtomicButton";
import variables from "../../global/assets/_variables.scss";
import { localStorageKeys } from "../../global/constants";
import { getUrlParams, getUrlPath, getUrlFullPath, removeParamFromUrl } from "../../global/getUrl";
import GreetingUser from "../../global/greetingUser"
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';


const HeaderLogin = () => {
    const { isLoggedIn, onLogout } = useContext(LoginDataContext);
    const { DEBUG_LOGOUT_POINT, TOKEN } = localStorageKeys;


    const hasTokens = localStorage.getItem(TOKEN);
    let decodedToken = null
    if (hasTokens) {
        decodedToken = jwt_decode(hasTokens);

    }

    const firstName = decodedToken?.firstName || 'Guest';
    const lastName = decodedToken?.lastName || 'Guest'


    const setLocalStorageDebug = async (param1, param2) => localStorage.setItem(param1, param2)
    const navigate = useNavigate();
    const triggerLogout = async () => {
        await onLogout()
        navigate('/onthemenu')
        window.location.reload()
        setLocalStorageDebug(DEBUG_LOGOUT_POINT, 'HeaderLogin HeaderLogin() NO-01')
    }

    const [popOverAnchor, setPopUpAnchor] = useState(null);

    const handleClick = (event) => {
        setPopUpAnchor(event.currentTarget);
    };

    const handleClose = () => {
        setPopUpAnchor(null);
    };

    const open = Boolean(popOverAnchor);
    const id = open ? "zipcode-popover-user-login" : undefined;

    const styleLabel = {
        fontFamily: 'Inter Light', fontSize: '14px', color: '#181436', cursor: "pointer", margin: '2px', letterSpacing: '0.4px',
        style2: {
            fontFamily: 'Inter Medium', fontSize: '14px', color: '#181436',
            margin: '0px 0px 10px 0px'
        }
    };

    const DisplayName = () => {
        return <div style={{ fontFamily: 'Inter light', fontSize: '14px', letterSpacing: '0.4px' }}> {GreetingUser()}
            <a style={{ textTransform: 'capitalize', fontFamily: 'Inter Medium', fontSize: '14px', letterSpacing: '0.4px' }}> {lastName}</a></div>
    }


    return (
        <div className="header-login ">

            {isLoggedIn ? <AtomicButton
                aria-describedby={id}
                label={DisplayName()}
                style={{
                    backgroundColor: `${variables.backgroundButtonBlack}`,
                    fontSize: '16px',
                }}
                handleSubmit={handleClick}
                endIcon={''}
                startIcon={<AccountCircleOutlinedIcon />} /> :

                <AtomicButton
                    label="Signin"
                    style={{
                        width: '20px',
                        backgroundColor: `${variables.backgroundButtonBlack}`,
                        fontSize: '16px',
                    }}
                    handleSubmit={() => navigate("/login")}
                    endIcon={''}
                    startIcon={<PersonOutlineOutlined />} />}



            <Popover
                id={id}
                open={open}
                anchorEl={popOverAnchor}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    // horizontal: "center",
                }}
            >


                <div style={{ display: 'flex', flexDirection: 'column', width: '200px', padding: '20px 30px' }}>
                    <div style={styleLabel.style2}>{GreetingUser()}</div>
                    <div style={styleLabel.style2}> Available combo plates</div>
                    <div style={styleLabel} onClick={() => navigate("/customeraccount/orders")}> Your Orders</div>
                    <div style={styleLabel} onClick={() => navigate("/customeraccount/deliveryaddress")}> Your addresses</div>
                    <div style={styleLabel} onClick={() => navigate("/customeraccount/subscription")}> Subscription </div>
                    <div style={styleLabel} onClick={() => navigate("/customeraccount/cards")}> Your Payments</div>
                    <div style={styleLabel} onClick={() => navigate("/customeraccount")}> Account </div>

                    <AtomicButton
                        label="Logout"
                        style={{
                            width: '100px',
                            backgroundColor: `${variables.backgroundButtonBlack}`,
                            fontSize: '12px',
                            height: '35px'
                        }}
                        handleSubmit={triggerLogout}
                        endIcon={''}
                        startIcon={<LogoutIcon sx={{ width: '20px' }} />} />

                </div>

            </Popover>


        </div>
    );
};

export default HeaderLogin;
HeaderLogin.propTypes = {
    screenSize: string,
    isLoggedIn: bool,
    logout: func
};
HeaderLogin.defaultProps = {
    screenSize: "",
};
